export const CHART_COLORS = {
  primary: '#1f9f93',
  primaryLight: '#2fb6aa',
  success: '#1dbf73',
  successLight: '#34d399',
  warning: '#ffb020',
  warningLight: '#fbbf24',
  error: '#e55353',
  errorLight: '#f87171',
  purple: '#8b5cf6',
  purpleLight: '#a78bfa',
  cyan: '#06b6d4',
  cyanLight: '#22d3ee',
  pink: '#ec4899',
  pinkLight: '#f472b6',
}

export const CATEGORY_COLORS = [
  '#1f9f93',
  '#8b5cf6',
  '#06b6d4',
  '#1dbf73',
  '#ffb020',
  '#ec4899',
  '#e55353',
  '#64748b',
]

export const lightTheme = {
  background: 'transparent',
  text: '#1d262d',
  textSecondary: 'rgba(29,38,45,.62)',
  grid: 'rgba(29,38,45,.08)',
  tooltipBg: 'rgba(231,234,235,.95)',
  tooltipBorder: 'rgba(29,38,45,.10)',
  tooltipText: '#1d262d',
  areaGradientStart: 'rgba(31,159,147,.35)',
  areaGradientEnd: 'rgba(31,159,147,.0)',
  dotStroke: '#fff',
}

export const darkTheme = {
  background: 'transparent',
  text: '#e2e8f0',
  textSecondary: 'rgba(226,232,240,.62)',
  grid: 'rgba(226,232,240,.08)',
  tooltipBg: 'rgba(26,35,48,.95)',
  tooltipBorder: 'rgba(226,232,240,.10)',
  tooltipText: '#e2e8f0',
  areaGradientStart: 'rgba(31,159,147,.35)',
  areaGradientEnd: 'rgba(31,159,147,.0)',
  dotStroke: '#1a2330',
}

export const getTheme = (isDark) => isDark ? darkTheme : lightTheme
